// extracted by mini-css-extract-plugin
module.exports = {"primary":"#3dbfbe","secondary":"#ea6f23","gray300":"#cccccc","gray400":"#b6b6b6"};